// import axios from "axios";
import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";
import qs from "qs";

export async function searchVideos(
  searchQuery: { [key: string]: any },
  mapMarkerIds?: string[] // Optional mapMarkerIds parameter
) {
  try {
    // Filter out null or empty string values from the query object
    const filteredQuery = Object.keys(searchQuery).reduce((acc: any, key) => {
      const value = searchQuery[key];
      // Only include non-null, non-empty string values
      if (value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    // Add mapMarkerIds to the query parameters if provided
    if (mapMarkerIds && mapMarkerIds.length > 0) {
      filteredQuery.mapMarkerIds = mapMarkerIds;
    }

    // Make the API call
    const resp = await axios.get(`/api/videos/search`, {
      params: filteredQuery,
      paramsSerializer: (params) => {
        // Serialize the params with arrayFormat for mapMarkerIds
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });

    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getVideos(pageNumber: number, pageSize: number) {
  try {
    const resp = await axios.get(
      `/api/videos/?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getMapMarkerVideos(
  mapMarkerIds: string[],
  pageNumber: number,
  pageSize: number,
  searchQuery?: string
) {
  try {
    // Build the mapMarker IDs part of the query string
    let queryString =
      mapMarkerIds
        .map((id) => `mapMarkerIds=${encodeURIComponent(id)}`)
        .join("&") + `&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    // Append the searchQuery if it is provided
    if (searchQuery) {
      queryString += `&searchQuery=${encodeURIComponent(searchQuery)}`;
    }

    const resp = await axios.get(
      `/api/videos/getMapMarkerVideos?${queryString}`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createVideo(newVideo: object) {
  try {
    const resp = await axios.put("/api/videos/create", newVideo);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getVideoDetails(videoId: string) {
  try {
    const resp = await axios.get(`/api/videos/${videoId}/details`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateVideo(updatedVideo: object) {
  try {
    const resp = await axios.post(`/api/videos/update`, updatedVideo);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function startEncoding(videoId: string) {
  try {
    const resp = await axios.post(`/api/videos/StartEncoding/${videoId}`);
    return resp;
  } catch (error) {
    console.error("Error starting encoding:", error);
    handleError(error);
  }
}

export async function updateVideoSpecies(
  videoId: string,
  speciesIds: string[]
) {
  try {
    const params = new URLSearchParams();
    params.append("videoGUID", videoId);
    speciesIds.forEach((id) => params.append("speciesGUIDs", id));

    const resp = await axios.post(
      `/api/videos/SetSpecies?${params.toString()}`
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
export async function updateVideoMapMarkers(
  videoId: string,
  mapMarkerIds: string[]
) {
  try {
    const params = new URLSearchParams();
    params.append("videoGUID", videoId);
    mapMarkerIds.forEach((id) => params.append("mapMarkerGUIDs", id));

    const resp = await axios.post(
      `/api/videos/SetMapMarkers?${params.toString()}`
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateVideoTags(videoId: string, tagIds: string[]) {
  try {
    const params = new URLSearchParams();
    params.append("videoGUID", videoId);
    tagIds.forEach((id) => params.append("tagGUIDs", id));

    const resp = await axios.post(`/api/videos/SetTags?${params.toString()}`);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteVideo(videoId: string) {
  try {
    const resp = await axios.delete(`/api/videos/delete?id=${videoId}`);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
export async function uploadThumbnail(videoId: string, thumbnailDto: object) {
  try {
    const params = new URLSearchParams();
    params.append("videoId", videoId);
    params.append("timestamp", Date.now().toString()); // Add timestamp to prevent caching

    const resp = await axios.post(
      `/api/videos/UploadThumbnail?${params.toString()}`,
      thumbnailDto
    );

    // Store the last update timestamp in localStorage to force thumbnail refresh
    localStorage.setItem("thumbnail_last_updated", Date.now().toString());
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function generatSasUrlForVideo(): Promise<string> {
  try {
    const resp = await axios.get(`/api/videos/folder-sas`);

    // Make sure to return the correct field (sasUri) from the response
    if (resp.data && typeof resp.data.sasUri === "string") {
      return resp.data.sasUri;
    } else {
      throw new Error("Invalid response format. Expected 'sasUri' field.");
    }
  } catch (error) {
    console.error("Error fetching SAS URL:", error);
    handleError(error);
    throw error; // Re-throw to let the caller know an error occurred
  }
}
